import { AssociatedEntityTypes } from '@libs/data';
import { AssociatedEntity } from './associated-entity';

export class AssociatedEntityHelper {
  static getIdByType(
    aes: AssociatedEntity[],
    aeType: AssociatedEntityTypes,
  ): string {
    return aes.find((x: AssociatedEntity) => x.type === aeType)?.id;
  }
  static getAssociatedEntityByType(
    aes: AssociatedEntity[],
    aeType: AssociatedEntityTypes,
  ): AssociatedEntity {
    return aes.find((x: AssociatedEntity) => x.type === aeType);
  }
}
